// The registration password rule (mobile src/utils/passwordRule.js): 12 characters with a capital
// letter, a number and a special character; the Kjuup+ / company-import form keeps its shorter
// 6-character minimum.
export const PASSWORD_MIN_LENGTH = 12;
export const PLUS_PASSWORD_MIN_LENGTH = 6;

const STRENGTH = /(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+|}{:"?><,./;'[\]\\-])/;

/** True when the password is `min` characters long with a capital, a digit and a special character. */
export const meetsPasswordRule = (password, min = PASSWORD_MIN_LENGTH) => {
  const value = String(password || "");
  return value.length >= min && STRENGTH.test(value);
};
